import { Component, OnInit } from '@angular/core';
import { NgxPermissionsService } from 'ngx-permissions';
import { CommonService } from './Service/Common.service';
import { EncrDecrService } from './Service/encr-decr.service';
import { LoaderService } from './Service/loader.service';
declare var $: any;
@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
    loading = true;
    constructor(
        private loadersrv: LoaderService,
        private commServ: CommonService,
        private permissionsService: NgxPermissionsService,
        private EncrDecr: EncrDecrService
    ) {
        this.loadersrv.mySubject.subscribe(
            value => {
                this.loading = value;
            }
        );
    }

    ngOnInit() {
        const perms = localStorage.getItem('Permissions');
        if (perms !== undefined && perms !== null) {
            const decrypted = this.EncrDecr.get(perms);
            const permissions: string[] = decrypted.toUpperCase().split(',');
            this.permissionsService.loadPermissions(permissions);
        }

        $.ajaxSetup({
            beforeSend: function (xhr) {
                const usertoken = localStorage.getItem('worqforctoken');
                if (usertoken !== undefined) {
                    xhr.setRequestHeader('Authorization', 'Bearer ' + usertoken);
                }
            },
            complete: function () {
                // $('#WaitLoader').hide();
            },
        });
    }
}
